var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scfForm",attrs:{"id":"nested-form"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.translationHelper.getTranslation('vdi_not_available'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }